__webpack_require__.O(0, ["welcome"], function() {
	["resources_src_js_share_components__font_family_js-_dce81","vendors-node_modules_jquery_dist_jquery_js","resources_src_js_share_components__welcome_lazy_js"].map(__webpack_require__.E);
}, 5);